import React from "react";
import "./Forecast.css";

export default function Forecast() {
  return (
    <div className="forecast-root">
      <div className="forecast-placeholder">
        <h1>Forecast</h1>
        <p>This page is under construction.</p>
        <p>Weather content has been removed for now.</p>
      </div>
    </div>
  );
}